import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { action } from 'satcheljs';

export const initializeOwaDateTimeStore = action(
    'initializeOwaDateTimeStore',
    (
        options: Pick<
            UserOptionsType,
            'DateFormat' | 'TimeFormat' | 'TimeZone' | 'MailboxTimeZoneOffset'
        >
    ) => ({
        DateFormat: options.DateFormat,
        TimeFormat: options.TimeFormat,
        TimeZone: options.TimeZone,
        MailboxTimeZoneOffset: options.MailboxTimeZoneOffset,
    })
);
